import './App.css';
import Main from './Components/Main/Main'

function App() {
  return (
    <Main />
  );
}

export default App;
